import { useEffect, useState } from 'react';
import type { Unsubscribe } from 'firebase/firestore';
import { arabicError } from '../lib/errors';

export function useLiveData<T>(subscribe: (success: (value: T) => void, failure: (error: Error) => void) => Unsubscribe, initial: T) {
  const [data, setData] = useState<T>(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => subscribe((value) => { setData(value); setLoading(false); }, (reason) => { setError(arabicError(reason)); setLoading(false); }), [subscribe]);
  return { data, loading, error };
}
